import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { AlertProps } from '../props/alert';
import Alert from '../components/Alert';

const propTypes = {
  group: PropTypes.string,
  alerts: PropTypes.arrayOf(AlertProps),
  clearAlerts: PropTypes.func
};

const defaultProps = {
  group: ''
};

export class AlertsContainer extends PureComponent {
  componentWillUnmount() {
    if (!this.props.clearAlerts) {
      return;
    }

    this.props.clearAlerts(this.props.group);
  }

  render() {
    const { alerts } = this.props;

    if (alerts.length === 0) {
      return null;
    }

    return (
      <div className="rec-notification-alerts-container">
        {alerts.map((item) => (
          <Alert key={item.id} alert={item} />
        ))}
      </div>
    );
  }
}

AlertsContainer.propTypes = propTypes;
AlertsContainer.defaultProps = defaultProps;

export const makeAlertsContainer = (selector, clearAlerts) => {
  const mapStateToProps = (state, props) => ({
    alerts: selector.getAlerts(state, props.group)
  });

  const mapDispatchToProps = (dispatch) => bindActionCreators({ clearAlerts }, dispatch);

  return connect(mapStateToProps, mapDispatchToProps)(AlertsContainer);
};
